import React from 'react';
import PropTypes from 'prop-types';
import { decl } from '@yandex-lego/i-bem-react';
import "./../../menu/__item/menu__item.react.js";
import "./../../../desktop.blocks/menu/__item/menu__item.react.js";
import _menu__item_type_link from "./../../menu/__item/_type/menu__item_type_link.react.js";

var MenuItem = _menu__item_type_link.applyDecls();

import _icon from "./../../icon/icon.react.js";

var Icon = _icon.applyDecls();

import "./../../icon/icon.css";
import "./../../menu/__text/menu__text.react.js";
import "./../__flag/lang-switcher__flag.css";
export default decl({
  block: 'lang-switcher',
  elem: 'lang',
  render: function render() {
    var _this$props = this.props,
        name = _this$props.name,
        lang = _this$props.lang,
        selected = _this$props.selected;

    if (lang && lang.lang && lang.name) {
      name = lang.name;
      lang = lang.lang;
    }

    selected = typeof selected === 'boolean' ? selected : selected === 'yes';
    var block = this.block,
        elem = this.elem,
        _this$props2 = this.props,
        mix = _this$props2.mix,
        url = _this$props2.url,
        noflags = _this$props2.noflags,
        flags = _this$props2.flags,
        onClick = _this$props2.onClick;
    var children = [];
    noflags || children.push(React.createElement(Icon, {
      key: "icon",
      mix: [{
        block: 'country-flag',
        mods: {
          s16: flags[lang]
        }
      }, {
        block: block,
        elem: 'flag'
      }],
      alt: ""
    }));
    children.push(name);
    return React.createElement(MenuItem, {
      isNavigation: true,
      type: "link",
      checked: selected,
      url: url,
      onClick: onClick,
      mix: [mix, {
        block: block,
        elem: elem
      }]
    }, children);
  }
}, {
  isLang: function isLang(child) {
    return child && typeof child.type === 'function' && child.type.displayName === 'lang-switcher__lang';
  },
  propTypes: {
    lang: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string,
    url: PropTypes.string,
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    noflags: PropTypes.bool,
    onClick: PropTypes.func
  }
});